import { pbacList } from '@/services/api-v3/pbac';
import { useState } from 'react';

export default () => {
  const [data, setData] = useState<API.PBAC[] | null>(null);
  const [valueEnum, setValueEnum] = useState<Record<string, string> | null>(null);

  const fetch = async () => {
    const res = await pbacList({ pageSize: -1 });
    setData(res.data);
    setValueEnum(
      res.data?.reduce(
        (pre: Record<string, string>, curr: API.PBAC) => ({ ...pre, [curr.id]: curr.name }),
        {},
      ),
    );
  };

  const reset = () => {
    setData(null);
    setValueEnum(null);
  };

  return {
    fetch,
    reset,
    data,
    valueEnum,
  };
};
